import classnames from 'classnames'
import PromoCode from 'shared/components/PromoCode'
import usePromoCodeData from 'shared/hooks/usePromoCodeData'

import styles from '../styles.module.scss'

const SUBSCRIPTION_PROMO_ITEM_ID = 0

const PromoCodeSection = ({ promoCodeBtnDisabled, rate }) => {
    const {
        rawPromoCode,
        setRawPromoCode,
        removePromoCode,
        onAddPromoCode,
        promoCodeError,
        successPromoCode,
        isPromoCodeLoading,
    } = usePromoCodeData({ currentItemIndex: SUBSCRIPTION_PROMO_ITEM_ID, rate })

    return (
        <div className={classnames('d-inline-flex mt-4 p-0', styles.promoCodeContainer)}>
            <PromoCode
                promoCodeValue={rawPromoCode}
                setRawPromoCode={setRawPromoCode}
                onRemovePromoCode={removePromoCode}
                onAddPromoCode={onAddPromoCode}
                removePromoCodeLabel={<T>booking.promocode.remove</T>}
                btnLabel={<T>booking.promocode.apply</T>}
                placeholder={<T>booking.hourly.flow.promocode.placeholder</T>}
                error={promoCodeError}
                success={successPromoCode}
                btnStyle="primary"
                label={<T>booking.hourly.flow.promocode.placeholder</T>}
                disabled={isPromoCodeLoading || promoCodeBtnDisabled}
                isLoading={isPromoCodeLoading}
            />
        </div>
    )
}

export default PromoCodeSection
